import { Svg } from "./svgHome.style";

export const SvgHome = () => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="8"
      viewBox="0 0 16 10"
      fill="none"
    >
      <path
        d="M10.8689 1L15 4.76471M15 4.76471L10.8689 9M15 4.76471H1"
        stroke="#FCFCFC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};
